import api from "./api";
import runtime from "config/runtime";
import TokenService from "./token.service";

const updateCopilotConversation = (copilotConversation) => {
  return api
    .patch("/copilot", {
      ...copilotConversation,
    })
    .then((response) => {
      return response.data;
    });
};


const getCopilotConversations = (search) => {
  return api
    .get("/copilot", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

const getCopilotPrompts = (search) => {
  return api
    .get("/copilot/prompt", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};



const getCopilotConversation = (id) => {
  return api.get("/copilot/" + id).then((response) => {
    return response.data;
  });
};

const getCopilotPrompt = (id) => {
  return api.get("/copilot/prompt/" + id).then((response) => {
    return response.data;
  });
};

const createCopilotConversation = (step) => {
  return api.post("/copilot", {
    ...step,
  });
};

const createCopilotPrompt = (step) => {
  return api.post("/copilot/prompt", {
    ...step,
  });
};

const getCopilotConversationFilterValues = (search) => {

  return api.get("/copilot/filtervalues",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getCopilotConversationUi = () => {
  return api.get("/copilot/ui")
  .then((response) => {
    return response.data;
  });
};

const getCopilotPromptFilterValues = (search) => {

  return api.get("/copilot/prompt/filtervalues",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getCopilotPromptUi = () => {
  return api.get("/copilot/prompt/ui")
  .then((response) => {
    return response.data;
  });
};

const updateCopilotFeedback = (prompt) => {
  return api
    .patch("/copilot/prompt", {
      ...prompt,
    })
    .then((response) => {
      return response.data;
    });
};

/**
 * Opens an SSE stream for the given promptId.
 * Returns an EventSource instance the caller is responsible for closing.
 *
 * @param {string} promptId
 * @param {{ onStatus, onResponse, onError, onDone }} handlers
 * @returns {EventSource}
 */
const streamCopilotPrompt = (promptId, { onStatus, onResponse, onError, onDone } = {}) => {
  const token = TokenService.getLocalAccessToken();
  const baseUrl = runtime.apiUrl || "/v1";
  // Strip trailing slash from base if present
  const base = baseUrl.replace(/\/$/, "");
  const url = `${base}/copilot/prompt/stream/${promptId}?token=${encodeURIComponent(token)}`;

  const es = new EventSource(url);

  // Track whether the stream completed normally so onerror can distinguish
  // a clean server-side close (after "done") from a genuine connection failure.
  let completed = false;

  es.addEventListener("status", (e) => onStatus && onStatus(e.data));

  es.addEventListener("response", (e) => {
    // Backend escapes newlines as \n to survive SSE framing. Unescape here.
    const text = e.data.replace(/\\n/g, "\n");
    onResponse && onResponse(text);
  });

  // "error" matches EventTypeError = "error" on the server side.
  // Previously this was "error_event" which never matched.
  es.addEventListener("error", (e) => {
    if (e.data) {
      onError && onError(e.data);
    }
  });

  es.addEventListener("done", () => {
    completed = true;
    es.close();
    onDone && onDone();
  });

  // The browser fires onerror both on genuine connection failures AND when the
  // server closes the connection normally (e.g. after sending "done"). Only
  // treat it as an error when the stream did not complete normally.
  es.onerror = () => {
    if (completed) {
      // Normal close after "done" — the stream already handled everything.
      return;
    }
    es.close();
    onError && onError("Connection lost");
  };

  return es;
};

const CopilotService = {
  createCopilotConversation,
  updateCopilotConversation,
  getCopilotConversations,
  getCopilotPrompts,
  getCopilotConversation,
  getCopilotPrompt,
  createCopilotPrompt,
  getCopilotConversationFilterValues,
  getCopilotPromptFilterValues,
  getCopilotConversationUi,
  getCopilotPromptUi,
  updateCopilotFeedback,
  streamCopilotPrompt,
};

export default CopilotService;
